import React, { Component } from 'react';
import { connect } from 'react-redux'
import api from "../helpers/apiClient";
import { Alert, Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import Input from '../components/Input';
import LoginNavbar from '../components/LoginNavbar';
import { trimLeft } from 'url-parse';

const giftrLink = window.location.hostname === 'seller.giftr.my' ? 'https://giftr.my' : 'https://giftr.sg'

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Required';
  }

  return errors
}


class ForgotPassword extends Component {

  constructor(props) {
    super(props)

    this.state = {
      sentMessage: null,
      error: null
    };
  }

  submit = (values) => {
    const { email } = values;
    this.setState({ error: null });
    return api('/auth/reset', {
      method: "post",
      body: JSON.stringify({ email })
    }).then(json => {
      this.setState({
        sentMessage: json.message
      })
    }).catch(e => {
      this.setState({
        error: (e && e.message) || 'We could not send the reset email. Please try again.'
      })
    })
  }

  render() {
    const { handleSubmit, submitting } = this.props
    const { sentMessage, error } = this.state

    return (
      <div>
        <LoginNavbar host={giftrLink}></LoginNavbar>
        <div className="row" id="pwd-container">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <form className="login-form d-grid gap-3 mx-3 shadow-sm" style={{textAlign: 'left', color:'#212529'}} onSubmit={handleSubmit(this.submit)}>
              <h4 className="mt-3 mb-5 text-center" style={{color:'#000'}}>Reset Password</h4>
              {
                error &&
                <Alert variant="danger">
                  <div>{error}</div>
                </Alert>
              }
              {
                sentMessage &&
                <Alert variant="success">
                  <div>{sentMessage} The link expires in 30 minutes.</div>
                </Alert>
              }
              <Field className="form-control" name="email" label="Enter your email address" placeholder="e.g. johndoe@helpr.my" type="email" component={Input} />
              <Button
                block="true"
                type="submit"
                disabled={!!sentMessage || submitting}
                className="mt-5"
              >{submitting ? 'SENDING...' : 'SEND RESET LINK'}</Button><br/>
            </form>
            </div>
            <div className="col-md-4"></div>
        </div>
      </div>
    );
  }
}

ForgotPassword = reduxForm({
  form: 'ForgotPassword',
  validate,
  destroyOnUnmount: true
})(ForgotPassword);

export default connect(state => {
  return {
    globalError: state.error,
  }
}, {})(ForgotPassword);
